<template>
    <div v-show="!(field.hide && field.hide())">
      <md-datepicker v-show="pageMode != 'view' && pageMode !== 'assignee'" v-model="vModelDate" md-immediately :key="name + '_input'"
                     :class="[
                  { 'md-valid': $vo[name] && Object.keys($vo[name].$params).length && !$vo[name].$invalid },
                  { 'md-error': $vo[name] && Object.keys($vo[name].$params).length && $vo[name].$invalid },
                  { '_uiKitInput': isUiKit },
                ]"
      >
        <label>{{field.label}}</label>
        <md-icon v-if="$vo[name] && Object.keys($vo[name].$params).length && $vo[name].$invalid">clear</md-icon>
        <md-icon v-else-if="$vo[name] && Object.keys($vo[name].$params).length && !$vo[name].$invalid">done</md-icon>
      </md-datepicker>
      <div v-show="pageMode == 'view' || pageMode == 'assignee'" :key="name + '_output'"  class="form-field-view md-field md-theme-default md-disabled _uiKitInput">
        <label>{{field.label}}:</label>&nbsp;
        <code class="md-input" v-if="displayDate == 'Invalid date'"></code>
        <code class="md-input" v-else>{{ displayDate }}</code>
      </div>
    </div>
</template>
<script>
  import moment from 'moment';
  export default {
    name: "crud-datepicker",
    components: {},
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $vo: {
        type: Object,
        required: true
      },
      format: {
        type: String,
        required: false
      },
      isUiKit: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      return {
        datePickerFormat: 'YYYY-MM-DD'
      }
    },
    computed: {
      displayDate() {
        if (this.field.format && this.form && this.name && this.form[this.name]) {
          return moment(this.form[this.name]).format(this.field.format);
        }
        return this.form[this.name];
      },
      vModelDate: {
        get () {
          return (this.$vo && this.name) ? this.$vo[this.name].$model ? moment(this.$vo[this.name].$model).format(this.datePickerFormat) : null : null;     
        },
        set (val) {
          if(this.$vo && this.name) 
            this.$vo[this.name].$model = moment(val).format(this.datePickerFormat)            
        }
      }
    }
  };
</script>